import { render } from "./ProjectAssignmentTypeForm.vue?vue&type=template&id=ee9a4440"
import script from "./ProjectAssignmentTypeForm.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__